<div id="login" appAppPerfectScrollbar>

    <div id="login-form-wrapper">

        <div id="login-form" appIfOnDom [@animate]="{
                value: '*',
                params: { duration: '300ms', x: '-50px' }
            }">

            <div class="logo">
                <img src="../../../../../assets/images/sendo/Marca.svg" style="width: 200px; height: 200px" />
            </div>
            <form name="loginForm">

                <div class="label-container text-center">
                    <mat-label class="fs-3">Ingresa el PIN que se ha enviado a tu correo</mat-label>
                </div>
                <div class="p-5">
                    <code-input [isCodeHidden]="false" [isCharsCode]="true" [codeLength]="6"
                        (codeChanged)="onChangeCode()" (codeCompleted)="onCodeCompleted($event)"
                        [isFocusingOnLastByClickIfFilled]="true">
                    </code-input>
                    @if (errorMessage) {
                    <div class="text-danger mt-2 text-center">
                        {{errorMessage}}
                    </div>
                    }
                </div>
                @if (countdown > 0) {
                <div class="alert alert-warning" role="alert">Por favor, espere {{countdown}} segundos antes de
                    volver a
                    enviar el pin</div>
                }
                <div>
                    <span class="fs-3">
                        <a class="d-flex justify-content-center align-items-center align-content-center resend-pin"
                            [class.disabled]="isButtonDisabled" (click)="resendCode()" role="button">
                            Reenviar Pin
                        </a>
                    </span>
                </div>
                <div class="p-3">
                    <a class="return-login" href="/login">
                        &lt; Regresar a Inicio de Sesión
                    </a>
                </div>
            </form>
        </div>
    </div>
</div>